// tslint:disable-next-line:class-name
export class CPfValidator {
  static TestaCPF(strCPF: string) {
    let Soma;
    let Resto;
    Soma = 0;

    strCPF = strCPF.replace(/\D+/g, "");

    if (strCPF === "00000000000") {
      return false;
    }
    if (strCPF === "11111111111") {
      return false;
    }
    if (strCPF === "22222222222") {
      return false;
    }
    if (strCPF === "33333333333") {
      return false;
    }
    if (strCPF === "44444444444") {
      return false;
    }
    if (strCPF === "55555555555") {
      return false;
    }
    if (strCPF === "66666666666") {
      return false;
    }
    if (strCPF === "77777777777") {
      return false;
    }
    if (strCPF === "88888888888") {
      return false;
    }
    if (strCPF === "99999999999") {
      return false;
    }

    // tslint:disable-next-line:radix
    for (let i = 1; i <= 9; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) {
      Resto = 0;
    }
    // tslint:disable-next-line:radix
    if (Resto !== parseInt(strCPF.substring(9, 10))) {
      return false;
    }

    Soma = 0;
    // tslint:disable-next-line:radix
    for (let i = 1; i <= 10; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    }
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) {
      Resto = 0;
    }
    // tslint:disable-next-line:radix
    if (Resto !== parseInt(strCPF.substring(10, 11))) {
      return false;
    }

    return true;
  }

  static TestaCNPJ(cnpj: any) {
    cnpj = cnpj.replace(/[^\d]+/g, "");
    if (cnpj === "") {
      return false;
    }
    if (cnpj.length !== 14) {
      return false;
    }
    const multiplicador1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const multiplicador2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma;
    let resto;
    let digito;
    let tempCnpj;

    // Elimina CNPJs invalidos conhecidos
    if (
      cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999"
    ) {
      return false;
    }

    tempCnpj = cnpj.substring(0, 12);
    soma = 0;
    for (let i = 0; i < 12; i++) {
      soma += Number.parseInt(tempCnpj[i].toString()) * multiplicador1[i];
    }
    resto = soma % 11;
    if (resto < 2) {
      resto = 0;
    } else {
      resto = 11 - resto;
    }
    digito = resto.toString();
    tempCnpj = tempCnpj + digito;
    soma = 0;
    for (let i = 0; i < 13; i++) {
      soma += Number.parseInt(tempCnpj[i].toString()) * multiplicador2[i];
    }
    resto = soma % 11;
    if (resto < 2) {
      resto = 0;
    } else {
      resto = 11 - resto;
    }
    digito = digito + resto.toString();
    return cnpj.endsWith(digito);
  }
}
